export default {
    categoryParentList: [],
    categoryList: [],
    categoryListCount: 0,
    categoryListForCreate: [],
}